import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getApp } from "firebase/app";

const FirebaseViewStay15s = () => {
  const location = useLocation();
  const app = getApp("ohyaGroupFirebase");
  const analytics = getAnalytics(app);

  useEffect(() => {
    const currentUrl = `${window.location.origin}${location.pathname}`;
    let startTime = Date.now();

    function handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        const endTime = Date.now();
        const stayTime = (endTime - startTime) / 1000; // Convert to seconds

        if (stayTime >= 15) {
          logEvent(analytics, "page_view_ohyagroup_15s", {
            page_location: currentUrl,
            value: stayTime,
          });
        }
      } else {
        startTime = Date.now(); // Reset start time when page becomes visible again
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up event listener when the component is unmounted or path changes
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [location]);

  return null;
};

export default FirebaseViewStay15s;
